import { Routes } from '@angular/router';
import { WorkOrderScheduleComponent } from './work-order-schedule/work-order-schedule';

export const routes: Routes = [
     {
    path: '',
    component: WorkOrderScheduleComponent,
    title: 'Home Page'
  },
];
